import { WebResource } from './WebResource';
export default WebResource;
